<template>
    <v-container fluid grid-list-md fill-height>
        <v-layout justify-center row wrap>
            <v-flex xs12 md6 class="mb-2">
                <user-data @submit="submit" header="Stammdaten" @error="error" v-model="user"></user-data>
            </v-flex>
            <v-flex xs12 md6>
                <user-options :disabled="user.gender === 'unknown'" v-model="user" @submit="submit" @error="error"></user-options>

                <password :disabled="user.gender === 'unknown'" :user="user" class="mt-2"></password>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import UserData from '../../components/UserData';
    import UserOptions from '../../components/UserOptions';
    import Password from '../../components/common/Password';
    import { mapState } from 'vuex';

    export default {
        components: {
            'user-data': UserData,
            'user-options': UserOptions,
            'password': Password
        },
        computed: mapState(['user']),
        methods: {
            submit() {
                this.$store.commit('snackBar', {
                    color: 'success',
                    text: 'Änderungen wurden gespeichert'
                });
            },
            error(msg) {
                if (!msg) {
                    msg = 'common_error';
                }

                this.$store.commit('snackBar', {
                    color: 'error',
                    text: this.$t(`errors.${msg}`)
                });
            }
        }
    }
</script>
